export const CLAIM_ROUTES = {
  myList: '/staff/claims',
  detail: '/staff/claims/:id',
  voucher: '/staff/claims/:id/voucher',
  financeQueue: '/staff/claims/finance',
  f5Export: '/staff/claims/export',
} as const;

/** Concrete voucher path for a claim id. */
export const claimVoucherPath = (id: string): string => `/staff/claims/${id}/voucher`;
